export default {
  rows: [],
  row: {},
  pagination: {
    current_page: 1,
    last_page: 0,
    per_page: 10,
    total: null
  },
  searchInfo: {},
  orderBy: [],
  tableOptions: {
    itemsPerPageOptions: [10, 15, 25, 50]
  },
  validations: {},
  errors: {}
}
